import { useEffect, useState, useRef } from 'react';

export const useDropdownKeyboardNavigation = ({
    items = [],
    state = false,
    onItemSelect,
    onItemControlEnterSelect,
    onItemAltCSelect,
    onItemAltDSelect,
    onItemAltASelect,
    onItemSpaceSelect,
    onItemAlt2Select,
    onItemAltISelect,
    onItemAltRSelect,
    onItemAltUSelect,
    onItemF2Select,
    onItemF3Select,
    onItemF4Select,
    onItemF5Select,
    onItemF6Select,
    onItemF7Select,
    onItemF8Select,
    onItemF9Select,
    onItemF10Select,
    onItemF11Select,
    onItemF12Select,
    onItemCtrlASelect,
    input_value = '',
    inputRef,
}) => {
    const [selectedItemIndex, setSelectedItemIndex] = useState(0);
    const lastSyncedValueRef = useRef(null);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (state) {
                // Check if the input associated with this dropdown is currently focused
                if (inputRef && inputRef.current && document.activeElement !== inputRef.current) {
                    return;
                }

                if (e?.key === 'ArrowUp') {
                    e?.preventDefault();
                    setSelectedItemIndex((prev) => Math?.max(prev - 1, 0));
                } else if (e?.key === 'ArrowDown') {
                    e?.preventDefault();
                    setSelectedItemIndex((prev) => Math?.min(prev + 1, items?.length - 1));
                } else if (e?.key === 'Enter' && !e?.ctrlKey) {
                    e?.preventDefault();
                    if (state) {
                        e?.stopPropagation(); // Prevent element listeners from firing
                    }
                    if (items && items[selectedItemIndex] && onItemSelect) {
                        onItemSelect(items[selectedItemIndex]);
                    }
                } else if (e?.ctrlKey && e?.key === 'Enter') {
                    e?.preventDefault();
                    if (state) {
                        e?.stopPropagation();
                    }
                    if (items && items[selectedItemIndex] && onItemControlEnterSelect) {
                        if (items[selectedItemIndex]?.alterEnabled === 0) {
                            return;
                        }
                        onItemControlEnterSelect(items[selectedItemIndex]);
                    }
                } else if (e?.altKey && (e?.key === 'c' || e?.key === 'C')) {
                    e?.preventDefault();
                    if (state) {
                        e?.stopPropagation();
                    }
                    if (items && items[selectedItemIndex] && onItemAltCSelect) {
                        onItemAltCSelect(items[selectedItemIndex]);
                    } else if (onItemAltCSelect) {
                        onItemAltCSelect();
                    }
                } else if (e?.altKey && (e?.key === 'd' || e?.key === 'D')) {
                    e?.preventDefault();
                    if (state) {
                        e?.stopPropagation();
                    }
                    if (items && items[selectedItemIndex] && onItemAltDSelect) {
                        onItemAltDSelect(items[selectedItemIndex]);
                    }
                } else if (e.altKey && (e.key === 'a' || e.key === 'A')) {
                    e?.preventDefault();
                    if (state) {
                        e?.stopPropagation();
                    }
                    if (items && items[selectedItemIndex] && onItemAltASelect) {
                        onItemAltASelect(items[selectedItemIndex]);
                    }
                } else if (e.key === ' ') {
                    if (state && onItemSpaceSelect) {
                        e?.preventDefault();
                        e?.stopPropagation();
                        if (items && items[selectedItemIndex]) {
                            onItemSpaceSelect(items[selectedItemIndex]);
                        }
                    }
                } else if (e.altKey && e.key === '2') {
                    e?.preventDefault();
                    if (state) {
                        e?.stopPropagation();
                    }
                    if (items && items[selectedItemIndex] && onItemAlt2Select) {
                        onItemAlt2Select(items[selectedItemIndex]);
                    }
                } else if (e.altKey && (e.key === 'i' || e.key === 'I')) {
                    e?.preventDefault();
                    if (state) {
                        e?.stopPropagation();
                    }
                    if (items && items[selectedItemIndex] && onItemAltISelect) {
                        onItemAltISelect(items[selectedItemIndex]);
                    }
                } else if (e.altKey && (e.key === 'r' || e.key === 'R')) {
                    e?.preventDefault();
                    if (state) {
                        e?.stopPropagation();
                    }
                    if (items && items[selectedItemIndex] && onItemAltRSelect) {
                        onItemAltRSelect(items[selectedItemIndex]);
                    }
                } else if (e.altKey && (e.key === 'u' || e.key === 'U')) {
                    e?.preventDefault();
                    if (state) {
                        e?.stopPropagation();
                    }
                    if (items && items[selectedItemIndex] && onItemAltUSelect) {
                        onItemAltUSelect(items[selectedItemIndex]);
                    }
                } else if (e.key === 'F2') {
                    e?.preventDefault();
                    /*if (state) {
                        e?.stopPropagation();
                    }*/
                    if (items && items[selectedItemIndex] && onItemF2Select) {
                        onItemF2Select(items[selectedItemIndex]);
                    }
                } else if (e.key === 'F3') {
                    e?.preventDefault();
                    if (state) {
                        e?.stopPropagation();
                    }
                    if (items && items[selectedItemIndex] && onItemF3Select) {
                        onItemF3Select(items[selectedItemIndex]);
                    }
                } else if (e.key === 'F4') {
                    e?.preventDefault();
                    if (state) {
                        e?.stopPropagation();
                    }
                    if (items && items[selectedItemIndex] && onItemF4Select) {
                        onItemF4Select(items[selectedItemIndex]);
                    }
                } else if (e.key === 'F5') {
                    e?.preventDefault();
                    if (state) {
                        e?.stopPropagation();
                    }
                    if (items && items[selectedItemIndex] && onItemF5Select) {
                        onItemF5Select(items[selectedItemIndex]);
                    }
                } else if (e.key === 'F6') {
                    e?.preventDefault();
                    if (state) {
                        e?.stopPropagation();
                    }
                    if (items && items[selectedItemIndex] && onItemF6Select) {
                        onItemF6Select(items[selectedItemIndex]);
                    }
                } else if (e.key === 'F7') {
                    e?.preventDefault();
                    if (state) {
                        e?.stopPropagation();
                    }
                    if (items && items[selectedItemIndex] && onItemF7Select) {
                        onItemF7Select(items[selectedItemIndex]);
                    }
                } else if (e.key === 'F8') {
                    e?.preventDefault();
                    if (state) {
                        e?.stopPropagation();
                    }
                    if (items && items[selectedItemIndex] && onItemF8Select) {
                        onItemF8Select(items[selectedItemIndex]);
                    }
                } else if (e.key === 'F9') {
                    e?.preventDefault();
                    if (state) {
                        e?.stopPropagation();
                    }
                    if (items && items[selectedItemIndex] && onItemF9Select) {
                        onItemF9Select(items[selectedItemIndex]);
                    }
                } else if (e.key === 'F10') {
                    e?.preventDefault();
                    if (state) {
                        e?.stopPropagation();
                    }
                    if (items && items[selectedItemIndex] && onItemF10Select) {
                        onItemF10Select(items[selectedItemIndex]);
                    }
                } else if (e.key === 'F11') {
                    e?.preventDefault();
                    if (state) {
                        e?.stopPropagation();
                    }
                    if (items && items[selectedItemIndex] && onItemF11Select) {
                        onItemF11Select(items[selectedItemIndex]);
                    }
                } else if (e.key === 'F12') {
                    e?.preventDefault();
                    if (state) {
                        e?.stopPropagation();
                    }
                    if (items && items[selectedItemIndex] && onItemF12Select) {
                        onItemF12Select(items[selectedItemIndex]);
                    }
                } else if (e.ctrlKey && (e.key === 'a' || e.key === 'A')) {
                    e?.preventDefault();
                    if (state) {
                        e?.stopPropagation();
                    }
                    if (items && items[selectedItemIndex] && onItemCtrlASelect) {
                        onItemCtrlASelect(items[selectedItemIndex]);
                    }
                }
            }
        };

        window.addEventListener('keydown', handleKeyDown, true);
        return () => {
            window.removeEventListener('keydown', handleKeyDown, true);
        };
    }, [items, selectedItemIndex, state, onItemSelect, onItemControlEnterSelect, onItemAltCSelect, onItemAltDSelect, onItemAltASelect, onItemSpaceSelect, onItemAlt2Select, onItemAltISelect, onItemAltRSelect, onItemAltUSelect, input_value]);

    useEffect(() => {
        if (selectedItemIndex >= items?.length) {
            setSelectedItemIndex(0);
        }
    }, [items?.length, selectedItemIndex]);

    const hasSyncedRef = useRef(false);

    useEffect(() => {
        if (!state) {
            lastSyncedValueRef.current = null;
            hasSyncedRef.current = false;
            return;
        }

        const isFreshOpen = lastSyncedValueRef.current === null;
        const valueChanged = input_value !== lastSyncedValueRef.current;

        if (isFreshOpen || valueChanged || !hasSyncedRef.current) {
            const index = items?.findIndex((item) => {
                const name = (item?.name || item?.ledger_name || item?.symbol || '')?.trim()?.toLowerCase();
                const searchValue = (input_value || '')?.trim()?.toLowerCase();
                return name === searchValue;
            });

            if (index !== -1) {
                setSelectedItemIndex(index);
                hasSyncedRef.current = true;
            } else if (isFreshOpen) {
                setSelectedItemIndex(0);
            }
            lastSyncedValueRef.current = input_value;
        }
    }, [state, input_value, items]);

    return { selectedItemIndex, setSelectedItemIndex };
};
